import { extendTheme, StyleFunctionProps } from '@chakra-ui/react';

const orangeAccentHex = '#EF5C36';

const aleaTheme = extendTheme({
  breakpoints: {
    sm: '480px',
    md: '768px',
    lg: '992px',
    xl: '1280px',
    '2xl': '1400px',
  },
  fonts: {
    heading: `'Poppins', sans-serif`,
    body: `'Poppins', sans-serif`,
  },
  styles: {
    global: {
      body: {
        fontFamily: `'Poppins', sans-serif`,
      },
    },
  },
  colors: {
    alea: {
      50: '#E3EDF1',
      100: '#B8CFD9',
      200: '#8CB0C1',
      300: '#6081A9',
      400: '#435F87',
      500: '#2B4956',
      600: '#24404D',
      700: '#1E3744',
      800: '#172E3B',
      900: '#101C29',
    },
    green: {
      50: '#E3F9E5',
      100: '#C1EAC5',
      200: '#A3D9A5',
      300: '#7BC47F',
      400: '#57AE5B',
      500: '#66EA6D',
      600: '#318230',
      700: '#207227',
      800: '#0E5814',
      900: '#05400A',
      default: '#66EA6D',
    },
    sunsetEmber: {
      500: '#EF5B35',
      default: '#EF5B35',
    },
    orangeAccent: {
      500: orangeAccentHex,
      default: orangeAccentHex,
    },
    invalid: {
      500: orangeAccentHex,
      default: orangeAccentHex,
    },
  },
  components: {
    Button: {
      baseStyle: {
        _disabled: {
          bg: 'white',
          color: 'gray.600',
          cursor: 'not-allowed',
          border: '1px solid gray.400',
          _hover: {
            bg: 'gray.200 !important',
          },
        },
      },
      variants: {
        solid: (props: StyleFunctionProps) => ({
          bg: props.colorMode === 'dark' ? 'alea.300' : 'alea.500',
          color: 'white',
          _hover: {
            bg: props.colorMode === 'dark' ? 'alea.200' : 'alea.600',
          },
          _disabled: {
            bg: 'white',
            color: 'gray.600',
            cursor: 'not-allowed',
            border: '1px solid gray',
          },
        }),
      },
    },
    Input: {
      variants: {
        'outline-only-bottom': {
          field: {
            border: 'none',
            borderBottom: '1px solid',
            borderColor: '#DCDCDC',
            borderRadius: '0',
            paddingLeft: '0',
            fontSize: { base: '14px', md: '20px' },
            fontWeight: 400,
            _focus: {
              boxShadow: 'none',
              borderBottom: '1px solid',
              borderColor: '#2B4956',
            },
            _placeholder: {
              color: '#C3C3C3',
            },
          },
        },
      },
    },
    Table: {
      variants: {
        simple: {
          tbody: {
            tr: {
              '&:nth-of-type(2n+2)': {
                'td, th': {
                  bg: '#f3f2f2',
                },
              },
            },
          },
        },
      },
    },
    Checkbox: {
      baseStyle: {
        control: {
          width: '25px',
          height: '25px',
          borderRadius: '5px',
          _checked: {
            bg: 'alea.500',
            borderColor: 'alea.500',
            _hover: {
              bg: 'alea.600',
              borderColor: 'alea.600',
            },
          },
        },
      },
    },
  },
});

export default aleaTheme;
